import React, { ReactElement } from "react";
import { Modal } from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "assets/styles/sort.scss";
import { useTranslation } from "react-i18next";

// scss at reset.scss under // bootstrap-modal
type modalProps = {
  onHide: () => void;
  show: boolean;
  title?: string;
  children?: React.ReactNode;
  closeButtonText?: string;
  dialogClassName?: string;
  backNavigation?: () => void;
  icon?: ReactElement;
  isWithFooter?: boolean;
  backdrop?: boolean | "static";
};

const ModalBootstrap = ({
  onHide,
  show,
  title,
  children,
  closeButtonText,
  dialogClassName,
  backNavigation,
  icon,
  isWithFooter = true,
  backdrop = true,
}: modalProps) => {
  const { t } = useTranslation();
  const closeText = closeButtonText ?? t("close");
  const handleOnHide = () => {
    if (backNavigation) {
      backNavigation();
    }
    onHide();
  };
  const renderClassName = () => {
    if (backNavigation) {
      return "btn blue arrowRight-white";
    }
    return "btn blue";
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
      show={show}
      dialogClassName={dialogClassName}
      backdrop={backdrop}
    >
      <Modal.Header closeButton className="custom-modal-header">
        <Modal.Title className="title-bold" id="contained-modal-title-vcenter">
          {icon}
          {` `}
          {title}
        </Modal.Title>
      </Modal.Header>

      {children && (
        <Modal.Body className="custom-modal-body">{children}</Modal.Body>
      )}
      {isWithFooter && (
        <Modal.Footer>
          <button
            type="button"
            onClick={handleOnHide}
            className={renderClassName()}
          >
            {closeText}
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalBootstrap;
